var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticStyle:{"width":"100vw"}},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.options,"autoresize":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }